'use client';

import { useId, type ReactNode } from 'react';
import { ensureBaselineStyle } from '../baseline/baseline-style';

export interface YesNoDayRowProps {
  /** The day, e.g. "Yesterday" or "Monday". */
  label: string;
  /** The date under it, when the row has one. */
  subtitle?: string;
  /**
   * The day's "No" and "Yes" answers: design-system `Chip`s (v9 Web/Chip, size
   * L), written at the call site so each carries its own action id.
   */
  children: ReactNode;
  'data-testid': string;
}

/**
 * v9 Web/Day row with a yes/no answer: the day and its date, then the answer
 * chips in a group named by the day, so each chip reads out as an answer for
 * that day with its pressed state.
 */
export function YesNoDayRow({
  label,
  subtitle,
  children,
  'data-testid': testId,
}: YesNoDayRowProps) {
  ensureBaselineStyle();
  const labelId = useId();
  return (
    <div className="signup-baseline__answer-row" data-testid={testId}>
      <div className="signup-baseline__answer-day">
        <span id={labelId} className="signup-baseline__answer-label">
          {label}
        </span>
        {subtitle ? <span className="signup-baseline__answer-date">{subtitle}</span> : null}
      </div>
      <div role="group" aria-labelledby={labelId} className="signup-baseline__answer-choices">
        {children}
      </div>
    </div>
  );
}
